import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Modal, ModalBody, ModalFooter } from 'reactstrap';
import * as types from '../../constants/prayerFeatureActionTypes';
import * as consts from '../../constants/prayerFeatureConstants';
import Text from '../common/input/text';
import Select from '../common/input/select';

function InputForm({
    memberId, data, connectionState, hasBanWord, hasPostError, hasEditPrayerError, hasEditCommentError,
    postPrayer, editPrayer, editComment, onActionComplete
}) {
    const [title, setTitle] = useState('');
    const [prayerMessage, setPrayerMessage] = useState('');
    const [topic, setTopic] = useState('');
    const [showError, setShowError] = useState(false);
    const [isAcceptTermsSelected, setIsAcceptTermsSelected] = useState(false);
    const [prayerCharsLeft, setPrayerCharsLeft] = useState(0);
    const [titleCharsLeft, setTitleCharsLeft] = useState(0);
    const [titleChanged, setTitleChanged] = useState(false);
    const [prayerMessageChanged, setPrayerMessageChanged] = useState(false);
    const [topicChanged, setTopicChanged] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const prayerTopics = [
        { label: 'COVID-19', value: 'COVID-19' },
        { label: 'Diagnosis', value: 'Diagnosis' },
        { label: 'Family', value: 'Family' },
        { label: 'Forgiveness', value: 'Forgiveness' },
        { label: 'Gratitude', value: 'Gratitude' },
        { label: 'Illness', value: 'Illness' },
        { label: 'Men’s Health', value: 'Men’s Health' },
        { label: 'Pediatrics', value: 'Pediatrics' },
        { label: 'Rehabilitation', value: 'Rehabilitation' },
        { label: 'Surgery', value: 'Surgery' },
        { label: 'Spiritual Care', value: 'Spiritual Care' },
        { label: 'Transplant', value: 'Transplant' },
        { label: 'Trauma', value: 'Trauma' },
        { label: 'Treatment', value: 'Treatment' },
        { label: 'Wellness', value: 'Wellness' },
        { label: 'Women’s Health', value: 'Women’s Health' },
    ];

    useEffect(() => {
        if (data) {
            if (!data.isComment) {
                setTitle(data.title);
                setTitleCharsLeft(data.title.length);
                setTopic(data.topics.length ? data.topics[0] : '');
            }
            setPrayerMessage(data.text);
            setPrayerCharsLeft(data.text.length);
            setTitleChanged(false);
            setPrayerMessageChanged(false);
            setTopicChanged(false);
        }
        else {
            reset();
        }
    }, [data]);

    window.addEventListener('popstate', (event) => {
        if (event.state) {
            setShowError(false);
        }
    }, false);

    const onFormSubmit = e => {
        setSubmitting(true);
        e.preventDefault();
        setShowError(false);
        window.history.pushState({ name: "browserBack" }, "on browser back click", window.location.href);
        let confirmationMessage = consts.ADD_POST_SUCCESS;
        const callback = (response, hasError) => {
            if (hasError) {
                setShowError(true);
            }
            else {
                reset();
                onActionComplete({ ...response, confirmationMessage });
            }
            setSubmitting(false);
        };
        if (!data) {
            postPrayer({ text: prayerMessage, title, topics: [topic] }, memberId, callback);
        } else if (!data.isComment) {
            confirmationMessage = consts.EDIT_POST_SUCCESS;
            editPrayer(data.postId, { text: prayerMessage, title, topics: [topic] }, memberId, callback);
        }
        else {
            confirmationMessage = consts.EDIT_POST_SUCCESS;
            editComment(data.commentId, prayerMessage, callback);
        }
    };

    const acceptTermsSelected = e => {
        if (e.target && e.target.checked) {
            setIsAcceptTermsSelected(true);
        } else {
            setIsAcceptTermsSelected(false);
        }
    };

    const reset = () => {
        setTitle('');
        setPrayerMessage('');
        setTopic('');
        setIsAcceptTermsSelected(false);
        setPrayerCharsLeft(0);
        setTitleCharsLeft(0);
    };

    return (
        <div className="prayer-form-container">
            <form onSubmit={onFormSubmit}>
                {(!data || !data.isComment) &&
                    <div className="form-group">
                        <Text
                            name="title"
                            placeholder="Title (Required)"
                            value={title}
                            required
                            onChange={e => {
                                const newValue = e.target.value;
                                setTitleChanged(!data || newValue !== data.title);
                                setTitle(newValue);
                                setTitleCharsLeft(newValue.length);
                            }}
                            required
                            autoFocus
                            maxSize={50}
                            minLength={5}
                            rows="3"
                            ShowCharCountMsg={true}
                            charsLeft={titleCharsLeft}
                            className="text-input"
                        />
                    </div>
                }
                <div className="form-group">
                    <Text
                        name="text"
                        placeholder="Message (Required)"
                        value={prayerMessage}
                        required
                        onChange={e => {
                            const newValue = e.target.value;
                            setPrayerMessageChanged(!data || newValue !== data.text);
                            setPrayerMessage(newValue);
                            setPrayerCharsLeft(newValue.length);
                        }}
                        required
                        autoFocus
                        maxSize={250}
                        minLength={25}
                        rows="6"
                        charsLeft={prayerCharsLeft}
                        ShowCharCountMsg={true}
                        className="text-input"
                    />
                </div>

                {(!data || !data.isComment) &&
                    <div className="form-group">
                        <Select
                            value={topic}
                            onChange={e => {
                                const newValue = e.target.value;
                                setTopicChanged(!data || newValue !== data.topics[0]);
                                setTopic(newValue);
                            }}
                            options={prayerTopics}
                            placeholder="Select a topic (Optional)"
                        />
                    </div>
                }
                {!data &&
                    <div className="form-group">
                        <label className="checkbox-container prayer-checkbox">
                            <input
                                type="checkbox"
                                onChange={acceptTermsSelected}
                                checked={isAcceptTermsSelected}
                            />
                            <span className="checkmark" />
                            <span className="submit-message">{consts.POST_ACKNOWLEDGMENT}</span>
                        </label>
                    </div>
                }

                <div className="prayer-btn-container">
                    <div className="col-12 col-md-6 prayer-form-btn">
                        <div className="text-md-left">
                            <button
                                type="button"
                                className="prayer-btn cancel-btn"
                                onClick={() => { reset(); onActionComplete(); }}
                            >
                                CANCEL
                            </button>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 prayer-form-btn text-md-right">
                        <button
                            type="submit"
                            className="prayer-btn"
                            disabled={
                                prayerCharsLeft < 25 || (titleCharsLeft < 5 && (!data || !data.isComment)) || (!isAcceptTermsSelected && !data) ||
                                (data && !prayerMessageChanged && (data.isComment || (!titleChanged && !topicChanged))) || submitting
                            }
                        >
                            SUBMIT
                        </button>
                    </div>
                </div>
            </form>
            <Modal
                className="prayerpost-modal"
                isOpen={showError && ((!data && hasPostError) || ((!data.isComment && hasEditPrayerError) || hasEditCommentError))}
                centered
            >
                <ModalBody>
                    {hasBanWord
                        ? consts.BAN_WORD_ERROR
                        : <div className="prayerpost-message">
                            {!data ? consts.ADD_POST_ERROR : (!data.isComment ? consts.EDIT_POST_ERROR : consts.EDIT_COMMENT_ERROR)}
                        </div>
                    }
                </ModalBody>
                <ModalFooter>
                    <div className="prayerpost-error-okay">
                        <button
                            type="button"
                            className="btn text-btn"
                            onClick={() => {
                                setShowError(false);
                            }}
                        >
                            OKAY
                        </button>
                    </div>
                </ModalFooter>
            </Modal>
        </div>
    );
}

const mapStateToProps = state => {
    return {
        hasPostError: state.prayerFeature.hasPostError,
        hasEditPrayerError: state.prayerFeature.hasEditPrayerError,
        hasEditCommentError: state.prayerFeature.hasEditCommentError,
        hasBanWord: state.prayerFeature.hasBanWord,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        postPrayer: (prayer, memberId, callback) => dispatch({ type: types.POST_PRAYER, prayer, memberId, callback }),
        editPrayer: (postId, textInput, memberId, callback) => {
            dispatch({ type: types.EDIT_PRAYER, postId, textInput, memberId, callback });
        },
        editComment: (commentId, textInput, callback) => {
            dispatch({ type: types.EDIT_COMMENT, commentId, textInput, callback });
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(InputForm);